/**
 * iurop-home-carousel.js — carruseles de la home Laganini (parcela C).
 *
 * Driver de pistas con scroll nativo: flechas que pasan una "página"
 * ([data-lg-prev]/[data-lg-next] sobre [data-lg-track] dentro de
 * [data-lg-carousel]), deshabilitadas en los extremos y ocultas si el
 * contenido cabe entero, y barra de progreso
 * opcional (.iurop-carousel-progress de base.css con [data-lg-progress] /
 * [data-lg-progress-thumb]).
 *
 * Nota: NO se reutiliza assets/iurop-best-sellers.js porque carece de guard
 * de carga (varios <script> con el mismo src ejecutan N veces y duplican
 * listeners). Este fichero lleva guard global y por raíz.
 *
 * Extra: toggle de los looks del "Compra el conjunto" en móvil
 * ([data-lg-dot] en "Compra el conjunto": tap abre el popup del hotspot).
 */
(function () {
  'use strict';

  if (window.__lgHomeCarouselInit) return;
  window.__lgHomeCarouselInit = true;

  function init(root) {
    if (root.__lgCarousel) return;
    root.__lgCarousel = true;

    var track = root.querySelector('[data-lg-track]');
    var prev = root.querySelector('[data-lg-prev]');
    var next = root.querySelector('[data-lg-next]');
    var anyArrow = prev || next;
    var arrows = anyArrow ? anyArrow.closest('.laganini-arrows') : null;
    var bar = root.querySelector('[data-lg-progress]');
    var thumb = root.querySelector('[data-lg-progress-thumb]');
    if (!track) return;

    function setDisabled(btn, off) {
      if (!btn) return;
      btn.toggleAttribute('disabled', off);
      btn.setAttribute('aria-disabled', off ? 'true' : 'false');
    }

    // Holgura: scrollLeft/scrollWidth son fraccionarios (anchos en calc/%) y
    // el extremo nunca cae en el entero exacto. Sin ella, una pista que cabe
    // justa se declara desbordada por medio pixel.
    var SLACK = 2;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var overflows = max > SLACK;

      // Sin desbordamiento no hay nada que pasar: fuera las dos flechas.
      if (arrows) {
        arrows.toggleAttribute('hidden', !overflows);
      } else {
        if (prev) prev.toggleAttribute('hidden', !overflows);
        if (next) next.toggleAttribute('hidden', !overflows);
      }
      setDisabled(prev, !overflows || track.scrollLeft <= SLACK);
      setDisabled(next, !overflows || track.scrollLeft >= max - SLACK);

      if (bar && thumb) {
        var frac = track.clientWidth / track.scrollWidth;
        if (frac >= 0.999) {
          bar.classList.add('is-hidden');
        } else {
          bar.classList.remove('is-hidden');
          thumb.style.width = frac * 100 + '%';
          // translateX en % del propio thumb: compone en GPU, sin lag móvil.
          thumb.style.transform =
            'translateX(' + (track.scrollLeft / track.clientWidth) * 100 + '%)';
        }
      }
    }

    function page(dir) {
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var current = Math.min(max, Math.max(0, track.scrollLeft));
      var target = Math.min(max, Math.max(0, current + dir * track.clientWidth));
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        page(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        page(1);
      });
    }
    // Sin requestAnimationFrame: no dispara con la pestana oculta y el estado
    // de las flechas se quedaria congelado (los eventos de scroll modernos ya
    // vienen agrupados por frame).
    track.addEventListener('scroll', update, { passive: true });
    // `load` no burbujea, en captura si: una imagen que llega tarde cambia el
    // ancho de la pista y con el si desborda o no.
    track.addEventListener('load', update, true);
    window.addEventListener('resize', update);

    if (window.ResizeObserver) {
      var ro = new window.ResizeObserver(function () {
        update();
      });
      ro.observe(track);
      if (track.firstElementChild) ro.observe(track.firstElementChild);
    }

    // La fuente de respaldo mide distinto: al cambiar a la definitiva el ancho
    // del contenido se mueve.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update).catch(function () {});
    }

    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lg-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  // ---- "Compra el conjunto": hoja movil del look --------------------------
  // En tactil el popup anclado desbordaba la tarjeta → tocar un punto abre
  // una hoja inferior (data-stl-sheet, una por seccion) con las prendas del
  // look, clonadas del <template data-stl-content> del propio look.
  var stlMobile = window.matchMedia('(max-width: 749px)');
  var openStlSheet = null;

  function closeStlSheet() {
    if (!openStlSheet) return;
    openStlSheet.classList.remove('is-open');
    openStlSheet.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lg-stl-sheet-open');
    openStlSheet = null;
  }

  function showStlSheet(look) {
    var sec = look.closest('.laganini-stl');
    if (!sec) return false;
    var sheet = sec.__lgSheet || sec.querySelector('[data-stl-sheet]');
    var tpl = look.querySelector('template[data-stl-content]');
    if (!sheet || !tpl || !tpl.content.childElementCount) return false;
    if (!sec.__lgSheet) {
      // Al <body>: fixed dentro de la seccion puede quedar atrapado por un
      // stacking context (P2). El listener va EN la hoja, sobrevive al move.
      document.body.appendChild(sheet);
      sec.__lgSheet = sheet;
      sheet.addEventListener('click', function (e) {
        if (e.target.closest('[data-stl-sheet-close]')) closeStlSheet();
      });
    }
    var body = sheet.querySelector('[data-stl-sheet-body]');
    if (!body) return false;
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    var count = look.querySelector('.laganini-stl__count');
    var title = sheet.querySelector('[data-stl-sheet-title]');
    if (count && title) title.textContent = count.textContent.trim();
    sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lg-stl-sheet-open');
    openStlSheet = sheet;
    // Reflow forzado y clase en sincrono, NO requestAnimationFrame: rAF no
    // dispara con la pestana oculta y la hoja se quedaria sin abrir.
    void sheet.offsetHeight;
    sheet.classList.add('is-open');
    return true;
  }

  // ---- "Compra el conjunto": hotspots -----------------------------------
  // Delegado en document (sobrevive a re-renders del editor). En desktop el
  // popup sale por :hover/:focus-within (CSS). En táctil, tocar el punto
  // abre la hoja movil; si no hay hoja, cae al popup .is-open de siempre.
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-lg-dot]');
    var insideHs = e.target.closest('[data-lg-hotspot]');

    // Cerrar los hotspots abiertos que no sean el actual
    document.querySelectorAll('[data-lg-hotspot].is-open').forEach(function (hs) {
      if (hs !== insideHs) {
        hs.classList.remove('is-open');
        var b = hs.querySelector('[data-lg-dot]');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });

    if (!dot) return;
    var hs = dot.closest('[data-lg-hotspot]');
    if (!hs) return;

    if (stlMobile.matches) {
      var look = dot.closest('[data-stl-look]');
      if (look && showStlSheet(look)) {
        e.preventDefault();
        return;
      }
    }

    // Si el popup ya está abierto, dejar que el enlace navegue; si no, abrir.
    if (!hs.classList.contains('is-open')) {
      e.preventDefault();
      hs.classList.add('is-open');
      dot.setAttribute('aria-expanded', 'true');
    }
  });

  // Esc cierra la hoja o el hotspot abierto
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeStlSheet();
    document.querySelectorAll('[data-lg-hotspot].is-open').forEach(function (hs) {
      hs.classList.remove('is-open');
      var b = hs.querySelector('[data-lg-dot]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  });
})();
